// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Right.css additions */
.inspector-card {
  width: 95%; 
  max-content: 400px;
  background: #1e1e1e; /* Slightly lighter than app bg */
  border: 1px solid #333;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.4);
}

.card-section-label {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  margin-bottom: 6px;
  text-transform: uppercase;
}

/* Row Data Styling (Orange Tint) */
.row-data-label { color: #e67e22; }
.row-data-box {
  background: #251a12; /* Dark orange tint */
  border-left: 3px solid #e67e22;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 12px;
}

/* Metadata Styling (Blue Tint) */
.meta-data-label { color: var(--accent); }
.meta-data-box {
  background: #121625; /* Dark blue tint */
  border-left: 3px solid var(--accent);
  padding: 8px;
  border-radius: 4px;
}

pre.code-block {
  margin: 0;
  font-size: 11px;
  color: #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-all;
}
`, "",{"version":3,"sources":["webpack://./src/TractumUI/components/Right/Right1.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB,EAAE,iCAAiC;EACtD,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC,kBAAkB,cAAc,EAAE;AAClC;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC,mBAAmB,oBAAoB,EAAE;AACzC;EACE,mBAAmB,EAAE,mBAAmB;EACxC,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB","sourcesContent":["/* Right.css additions */\n.inspector-card {\n  width: 95%; \n  max-content: 400px;\n  background: #1e1e1e; /* Slightly lighter than app bg */\n  border: 1px solid #333;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 12px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.4);\n}\n\n.card-section-label {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 1px;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n}\n\n/* Row Data Styling (Orange Tint) */\n.row-data-label { color: #e67e22; }\n.row-data-box {\n  background: #251a12; /* Dark orange tint */\n  border-left: 3px solid #e67e22;\n  padding: 8px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n/* Metadata Styling (Blue Tint) */\n.meta-data-label { color: var(--accent); }\n.meta-data-box {\n  background: #121625; /* Dark blue tint */\n  border-left: 3px solid var(--accent);\n  padding: 8px;\n  border-radius: 4px;\n}\n\npre.code-block {\n  margin: 0;\n  font-size: 11px;\n  color: #ccc;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
